import { Clipboard }                                    from '@angular/cdk/clipboard';
import { Component, OnInit, OnDestroy, Inject, NgZone } from '@angular/core';
import { AnimationEvent }                               from '@angular/animations';

import { ToastData, TOAST_CONFIG_TOKEN, ToastConfig } from './toast-manager.config';
import { ToastRef }                                   from './toast-ref.model';
import { toastAnimations, ToastAnimationState }       from './toast-animation';

@Component({
						 standalone: false,
						 selector:    'cs-toast',
						 templateUrl: './toast.component.html',
						 animations:  [toastAnimations.fadeToast]
					 })
export class ToastComponent implements OnInit,
																			 OnDestroy {
	animationState: ToastAnimationState = 'default';
	iconType: string;
	// Progress bar variables
	progressWidth    = 0;
	showProgressBar: boolean;
	showCloseButton: boolean;
	/**
	 * Used for setting the correct icon when copy to clipboard
	 */
	isCopied         = false;

	constructor(
		readonly data: ToastData,
		readonly ref: ToastRef,
		private zone: NgZone,
		private readonly clipboard: Clipboard,
		@Inject(TOAST_CONFIG_TOKEN) public toastConfig: ToastConfig
	) {
		this.iconType        = data.iconClass;
		this.showProgressBar = data.showProgressBar ?? true;
		this.showCloseButton = data.showCloseButton ?? true;
	}

	ngOnInit() {
		if (!this.data.clickToClose)
			this.startTimeOut();
	}

	ngOnDestroy() {
		clearTimeout(this.intervalId);
	}

	close() {
		// Trigger the animation for closing
		this.zone.run(() => this.animationState = 'closing');
	}

	copyToClipboard($event: MouseEvent) {
		$event.stopImmediatePropagation();
		$event.stopPropagation();
		$event.cancelBubble = true;
		this.isCopied       = true;
		this.clipboard.copy(this.data.copyToClipboardText);
	}

	onFadeFinished(event: AnimationEvent) {
		const {toState}  = event;
		const isFadeOut  = (toState as ToastAnimationState) === 'closing';
		const itFinished = this.animationState === 'closing';

		if (isFadeOut && itFinished) {
			this.ref.close();
		}
	}

	startTimeOut(): void {
		const timeout = (this.data.timeOut || this.toastConfig.timeOut) / 10;
		this.steps    = timeout;
		this.speed    = timeout / this.steps;
		this.start    = new Date().getTime();
		this.zone.runOutsideAngular(() => this.timer = setTimeout(this.instance, this.speed));
	}


	onEnter(): void {
		if (this.toastConfig.pauseOnHover) {
			this.stopTime = true;
		}
	}

	onLeave(): void {
		if (this.toastConfig.pauseOnHover) {
			this.stopTime = false;
			setTimeout(this.instance, (this.speed - this.diff));
		}
	}

	private intervalId: number;
	private stopTime = false;
	private timer: any;
	private steps: number;
	private speed: number;
	private count    = 0;
	private start: any;
	private diff: any;

	private instance = () => {
		this.zone.runOutsideAngular(() => {
			this.zone.run(() => this.diff = (new Date().getTime() - this.start) - (this.count * this.speed));

			if (this.count++ === this.steps) {
				this.zone.run(() => this.animationState = 'closing');
			} else if (!this.stopTime) {
				if (this.showProgressBar) {
					this.zone.run(() => this.progressWidth += 100 / this.steps);
				}

				this.timer = setTimeout(this.instance, (this.speed - this.diff));
			}
		});
	}
}
